import React, { useState, useEffect } from 'react';
import { Container, Header, Title, Text, Button, Icon, Footer, Left, Body, Right, ListItem, Content, Separator, View, Card, CardItem, H3 } from 'native-base';
import { Platform, Linking, WebView, StyleSheet } from 'react-native';
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder';
import Constants from 'expo-constants';
import * as WebBrowser from 'expo-web-browser';
import CalCalDataApi from '../../api/CalCalDataApi';
import Alert from '../../components/alert';
import SelItem from './selItem';
import Modal from '../../components/modal';

export default function SaPrePop({ jwt, navigation, taxyear }) {
	const [error, setError] = useState(null);
	const [utr, setUtr] = useState();
	const [showModal, setShowModal] = useState(false);

	const dev = __DEV__ ? '?dev=true' : '';

	const [connectedHMRC, setConnected] = useState(null); // do we have the link?
	useEffect(() => {
		//on first render, load
		if (connectedHMRC == null)
			CalCalDataApi.dataLoad('sa/prepop' + dev, jwt, res => {
				if (__DEV__) console.log(res);

				if (!res.error) {
					setConnected(res.connected);
				} else if (res.status && res.status == 403) {
					setError({ loading: 'pre-population', error: 'Not licensed' });
					Alert.alert('Not yet licensed', `You still need to pay to send your tax return. You can do this now or at the end.`, [
						{ text: 'Pay later', onPress: () => setShowModal(false) },
						{ text: 'Pay now', onPress: () => navigation.navigate('SubscriptionContainer') }
					]);
				} else {
					setConnected(false);
					setError({ loading: 'pre-population', error: res.error });
					setUtr(res.utr);
				}
			});
	}, []);

	const [prepopAuthUrl, setPrepopAuth] = useState(null); // get auth url
	const redirectUrl = Platform.OS == 'web' ? window.location.origin + '/redirect' : 'https://calc.al/api/sa/prepop/redirect?r=calcal://SaDetails/' + taxyear;
	//console.log(Linking.getInitialURL());
	//console.log(Constants.manifest);
	//the above redirect just redirects to 'r'. Reason: HMRC won't accept custom URL scheme (calcal://). So double-hop.

	useEffect(() => {
		if (connectedHMRC === false)
			CalCalDataApi.dataLoad(`sa/prepop/authUrl?redirect=${redirectUrl}&dev=${__DEV__}`, jwt, res => {
				if (__DEV__) console.log(res);

				if (!res.error && res.success) {
					setPrepopAuth(res.authUrl);
					setUtr(res.utr);
				} else {
					setError({ loading: 'pre-population', error: typeof res.error == 'text' ? res.error : res.message });
				}
			});
	}, [connectedHMRC]); //When connectedHMRC changes

	const urlCallback = event => {
		if (handledCallback) return;
		setHandled(true);
		//this.urlCallback && Linking.removeEventListener('url', this.urlCallback);
		const code = event.url.substring(event.url.lastIndexOf('/') + 1);
		if (code) {
			//save code, set connected to null
			CalCalDataApi.dataInsert('sa/prepop/code', { code, redirectUrl, dev: __DEV__ }, jwt, res => {
				if (res.success) {
					setConnected(true);
				} else {
					setError({ loading: 'code', error: res.error?.error || res.error });
				}
			});
		}
	};

	//open web browser
	const [handledCallback, setHandled] = useState(false);
	const doConnect = async () => {
		if (!prepopAuthUrl) return Alert.alert('Error', 'Not got auth url from HMRC. Please try again later');
		setHandled(false);
		Linking.addEventListener('url', ev => urlCallback(ev));
		const result = await WebBrowser.openAuthSessionAsync(prepopAuthUrl, redirectUrl);
		__DEV__ && console.log(result);
		if (result && result.type == 'success' && result.url) {
			const code = result.url.split('code=')[1];
			CalCalDataApi.dataInsert('sa/prepop/code', { code, redirectUrl, dev: __DEV__ }, jwt, res => {
				if (res.success) {
					setConnected(true);
				} else {
					setError({ loading: 'code', error: res.error?.error || res.error });
				}
			});
		}
	};

	const [info, setInfo] = useState(null); //   {tax: 'Found something', nationalinsurance: 'Error: Cant find', marriageallowance: 'Message'}
	useEffect(() => {
		if (connectedHMRC) loadInfo();
	}, [connectedHMRC]); // when connectedHMRC, load info

	const loadInfo = () => {
		CalCalDataApi.dataLoad('sa/prepop/sync/' + taxyear + dev, jwt, res => {
			if (__DEV__) console.log(res);

			if (!res.error) {
				setInfo(res.info);
			} else {
				setError({ loading: res.failed || 'info', error: res.error });
			}
		});
	};
	//console.log(error);

	return (
		<>
			{!info ? (
				<SelItem
					icon="checkmark"
					text="Import data"
					rText={`(optional)`}
					rSubText={`Marriage Allowance\n & NI Contributions`}
					subText="from HMRC"
					colour="#DDD"
					rightIcon={'ios-open'}
					onPress={() => setShowModal(true)}
				/>
			) : (
				<>
					<SelItem
						icon={info.mallow && info.mallow.success ? 'checkmark' : 'close-circle-outline'}
						text="Marriage Allowance"
						rText={info.mallow && info.mallow.text}
						rSubText={info.mallow && info.mallow.subtext}
						colour={info.mallow && info.mallow.success ? '#080' : '#EA1'}
						rightIcon={false}
						onPress={() => setShowModal(true)}
					/>
					<SelItem
						icon={info.nics && info.nics.success ? 'checkmark' : 'close-circle-outline'}
						text="NI Contributions"
						rText={info.nics && info.nics.text}
						rSubText={info.nics && info.nics.subtext}
						colour={info.nics && info.nics.success ? '#080' : '#EA1'}
						rightIcon={false}
						onPress={() => setShowModal(true)}
					/>
				</>
			)}
			<Modal
				isOpen={showModal}
				backdropPressToClose
				useNativeDriver
				backButtonClose
				backdropOpacity={0.5}
				coverScreen
				style={{ height: 'auto', backdropColor: 'transparent' }}
				swipeThreshold={100}
				onClosed={() => setShowModal(false)}>
				<Card>
					<View style={{ flexDirection: 'row' }}>
						<CardItem header bordered style={{ flexDirection: 'column', alignItems: 'flex-start', flex: 1 }}>
							<Text>Live Connection</Text>
							{connectedHMRC ? <Text note>You've connected to HMRC.</Text> : <Text note>Import data from HMRC</Text>}
						</CardItem>
						<CardItem>
							<Button transparent onPress={() => setShowModal(false)}>
								<Text>Close</Text>
							</Button>
						</CardItem>
					</View>

					<CardItem style={{ flexDirection: 'column', alignItems: 'stretch' }}>
						{connectedHMRC === false && <Text note>Allow CalCal read access to your Personal Tax Account to pre-fill some of your self-assessment forms.</Text>}
						{(connectedHMRC === null || (connectedHMRC === false && !prepopAuthUrl)) && !error && <ShimmerPlaceHolder autoRun />}
						{connectedHMRC === false && prepopAuthUrl && (
							<Button bordered success onPress={doConnect}>
								<Text>Connect</Text>
							</Button>
						)}
						{connectedHMRC && !error && (
							<>
								{!info && <Text>Loading data...</Text>}
								{info && (!info.mallow.success || !info.nics.success) && (
									<Text style={{ paddingBottom: 5 }}>Not all data could be loaded.{`\n`}Don't worry, you'll be able to fill in these boxes manually.</Text>
								)}
							</>
						)}
						{error && (
							<>
								<Text>Error... {error.error && (error.error.message || error.error)}</Text>

								<Button
									bordered
									onPress={() => {
										setConnected(false);
										setError(null);
									}}>
									<Text>Reset</Text>
								</Button>
							</>
						)}
						{connectedHMRC && (
							<View style={{ flexDirection: 'row', justifyContent: 'space-between', alignContent: 'space-between' }}>
								<Button
									bordered
									onPress={() => {
										setConnected(false);
										setError(null);
									}}>
									<Text>Reconnect</Text>
								</Button>
								<Button bordered style={{ alignSelf: 'flex-end' }} onPress={loadInfo}>
									<Text>Refresh Data</Text>
								</Button>
							</View>
						)}
					</CardItem>
				</Card>
			</Modal>
		</>
	);
}

const styles = StyleSheet.create({
	headerTxt: {
		color: '#EEE'
	}
});
